import asscherImage from '@shared/public/images/cut/asscher.png';
import cushionImage from '@shared/public/images/cut/cushion.png';
import emeraldImage from '@shared/public/images/cut/emerald.png';
import heartImage from '@shared/public/images/cut/heart.png';
import marquiseImage from '@shared/public/images/cut/marquise.png';
import ovalImage from '@shared/public/images/cut/oval.png';
import pearImage from '@shared/public/images/cut/pear.png';
import princessImage from '@shared/public/images/cut/princess.png';
import radiantImage from '@shared/public/images/cut/radiant.png';
import roundImage from '@shared/public/images/cut/round.png';

import asscherSampleImage from '@shared/public/images/cut/asscher_sample.jpg';
import cushionSampleImage from '@shared/public/images/cut/cushion_sample.jpg';
import emeraldSampleImage from '@shared/public/images/cut/emerald_sample.jpg';
import heartSampleImage from '@shared/public/images/cut/heart_sample.jpg';
import marquiseSampleImage from '@shared/public/images/cut/marquise_sample.jpg';
import ovalSampleImage from '@shared/public/images/cut/oval_sample.jpg';
import pearSampleImage from '@shared/public/images/cut/pear_sample.jpg';
import princessSampleImage from '@shared/public/images/cut/princess_sample.jpg';
import radiantSampleImage from '@shared/public/images/cut/radiant_sample.jpg';
import roundSampleImage from '@shared/public/images/cut/round_sample.jpg';

const shapeImages = {
  round: roundImage,
  pear: pearImage,
  princess: princessImage,
  oval: ovalImage,
  emerald: emeraldImage,
  cushion: cushionImage,
  marquise: marquiseImage,
  heart: heartImage,
  radiant: radiantImage,
  asscher: asscherImage,
};

const shapeSampleImages = {
  round: roundSampleImage,
  pear: pearSampleImage,
  princess: princessSampleImage,
  oval: ovalSampleImage,
  emerald: emeraldSampleImage,
  cushion: cushionSampleImage,
  marquise: marquiseSampleImage,
  heart: heartSampleImage,
  radiant: radiantSampleImage,
  asscher: asscherSampleImage,
};

export { shapeImages, shapeSampleImages };
